import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";

export async function putPasswords(id, data) {
  const url = URL.setId(URL.buildUrl("passwords"), id);
  const response = await new API(url).put(data);
  return response;
}
